<template>
  <div class="k-fields-repeater">
    <draggable
      :list="items"
      group="fields"
      animation="150"
      handle=".drag-handle"
      class="drag-app-widgets-items"
      @end="$emit('update:modelValue', items)"
    >
      <div v-for="(item, index) in items" :key="index" class="k-fields-repeater-item">
        <!-- Drag handle -->
        <v-btn
          class="drag-handle"
          color="var(--primary)"
          density="compact"
          variant="text"
          size="small"
        >
          <i class="fal fa-ellipsis-v"></i>
        </v-btn>

        <!-- Label (filter name) -->
        <div class="input-col">
          <tip-tap-input v-model="item.name" @update:modelValue="update" />
        </div>

        <!-- Select (choose a field) -->
        <div class="tiptap-col">
          <v-select
            v-model="item.selected_field"
            :items="fields"
            item-title="label"
            hide-details
            class="bg-filled-input"
            placeholder="Selecteer veld"
            return-object
            variant="solo"
            density="compact"
            @update:modelValue="update"
            menu-icon="fal fa-chevron-down"
            :menu-props="{ class: 'kyano-menu' }"
          />
        </div>

        <!-- Remove button -->
        <div class="btn-col">
          <v-btn
            color="var(--danger)"
            variant="text"
            size="x-small"
            icon
            class="btn btn-sm"
            @click="removeRow(index)"
          >
            <i class="fal fa-times"></i>
          </v-btn>
        </div>
      </div>
    </draggable>

    <div class="text-right">
      <v-btn
        @click="addItem"
        class="btn btn-sm px-1 ml-auto text-right"
        color="var(--primary)"
        density="compact"
        variant="text"
        size="x-small"
      >
        <i class="fal fa-plus mr-2"></i> {{ $t("add") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import TipTapInput from "@/components/TipTapInput.vue";
  import { VueDraggableNext } from "vue-draggable-next";
  export default {
    name: "KFieldsRepeater",
    props: {
      modelValue: {
        type: Array,
        default: () => [],
      },
      fields: {
        type: Array,
        default: () => [],
      },
    },

    components: {
      TipTapInput,
      draggable: VueDraggableNext,
    },
    data() {
      return {};
    },
    computed: {
      items: {
        get() {
          return this.modelValue;
        },
        set(newItems) {
          console.log("newItems", newItems);
          this.$emit("update:modelValue", newItems);
        },
      },
    },
    methods: {
      addItem() {
        const newItems = [...this.items];
        newItems.push({
          name: ``,
          value: null,
          type: "",
        });
        this.items = newItems;
      },

      update() {
        this.$emit("update:modelValue", this.items);
      },
      removeRow(index) {
        this.items.splice(index, 1);
        this.$emit("update:modelValue", this.items);
      },
    },
  };
</script>

<style>
  .k-fields-repeater {
    display: block;
    width: 100%;

    .k-fields-repeater-item {
      display: flex;
      width: 100%;
      gap: 4px;
      margin-bottom: 5px;
      position: relative;

      .drag-handle {
        position: absolute;
        padding: 0px;
        min-width: 0px !important;
        width: 10px !important;
        height: 100% !important;
        left: -10px;

        .v-btn__content {
          font-size: 20px;
        }
      }

      .input-col {
        width: 60%;
      }

      .tiptap-col {
        width: 54%;
      }

      .btn-col {
        width: 6%;
      }
    }
  }
</style>
